import { IBuilderComponent } from "@faire/builder-core/registerBuilderComponents/types";
import { IFlexProps } from "@faire/web/slate/Layout/Flex";

export const BuilderConfig: IBuilderComponent<
  IFlexProps,
  Partial<IFlexProps>
> = {
  name: "Row",
  relativePath: "./Row.tsx",
  propDefinition: {
    name: "IFlexProps",
    path: "../Flex.tsx",
  },
  transformations: {
    flex: null,
  },
  canHaveChildren: true,
  hideFromInsertMenu: true,
};
